// extracted by mini-css-extract-plugin
export default {"container":"InputButtons_container__n2p6P","button":"InputButtons_button__yOMlL"};